import { TChapter } from "@/zapi-frontend/shared/types/projects";
import { SidebarMarketIcon, SidebarStrategyIcon, SidebarFinancialIcon } from "@libs/zapi-ui/assets";

export const FULL_SUMMARY_SLUG = "executive-summary-10-pager";
export const EXEC_SUMMARY_SLUG = "executive-summary";

export const DEEP_DIVE_SECTIONS = [
  { key: "market-analysis", labelKey: "sidebar.marketAnalysis", Icon: SidebarMarketIcon },
  { key: "strategy-analysis", labelKey: "sidebar.strategyAnalysis", Icon: SidebarStrategyIcon },
  { key: "financial-analysis", labelKey: "sidebar.financialAnalysis", Icon: SidebarFinancialIcon }
] as const;

export function isAppendixChapter(chapter: TChapter) {
  return chapter.tag === "iq_generated_appendix" || chapter.projectTemplateChapter.slug.startsWith("appendix-");
}

// Template-less (claude-code) projects have a single summary chapter, presented as the Innovera Memo.
export function getExecSummaryLabelKey(isTemplateLess: boolean) {
  return isTemplateLess ? "sidebar.innoveraMemo" : "sidebar.executiveSummary";
}

export function findExecSummaryChapter(chapters: TChapter[]) {
  return (
    chapters.find((c) => c.projectTemplateChapter.slug === EXEC_SUMMARY_SLUG) ??
    chapters.find(
      (c) => c.projectTemplateChapter.isExecutiveSummary && c.projectTemplateChapter.slug !== FULL_SUMMARY_SLUG
    )
  );
}
